import React from "react";
import { Tooltip } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { DEPENDENCY_LINKING_TO_LONG_TEXT } from "../../utils";
const DependencyLinking = ({ linking, }) => {
    return (React.createElement(Tooltip, { trigger: "term", placement: "bottom", title: DEPENDENCY_LINKING_TO_LONG_TEXT[linking] },
        React.createElement("span", null, capitalizeFirstLetter(linking))));
};
export default DependencyLinking;
//# sourceMappingURL=DependencyLinking.js.map